import { generateJsonWebToken, checkAndGetSessionStorageValue, checkAndGetLocalStorageValue } from "../../../features/utils";
function switchResult(selectedCareOptionName) {
  switch (selectedCareOptionName) {
    case 'Clinic':
      return 2;
    case 'Retail Clinic':
      return 5;
    case 'Urgent Care':
      return 3;
    case 'Emergency Room':
      return 4;
    case 'Medical Facility':
      return 12;

    default:
      return 0;
  }
}

export async function submitTriageFacility({ state, actions, clinic }) {
  const { triageRequest } = state
  const {

    selectedCareOptionName,
    sessionId

  } = triageRequest

  var jwtAccess_Token = generateJsonWebToken()
  var access_Token = checkAndGetSessionStorageValue("accessToken")
  const encounterToken = localStorage.getItem('token')

  let coordinationType = switchResult(checkAndGetLocalStorageValue('careoption'))
  const data = {
    identifier: sessionId,
    token: encounterToken,
    FacilityName: triageRequest.selectedProvider.name,
    FacilityAddress: triageRequest.locationMeta.enteredLocationName,
    CoordinationType: coordinationType,
    jwtAccessToken: jwtAccess_Token,
    accessToken: access_Token,
  }

  actions.sendTriageRequest({ action: 'UpdateFacilityCoordination', data })
}